export type OwaspRiskFactorKey =
  | 'SL'
  | 'M'
  | 'O'
  | 'S'
  | 'ED'
  | 'EE'
  | 'A'
  | 'ID'
  | 'LC'
  | 'LI'
  | 'LA'
  | 'LAc'
  | 'FD'
  | 'RD'
  | 'NC'
  | 'PV';

export type OwaspRiskFactors = Record<OwaspRiskFactorKey, number>;

export type OwaspRiskFactorLevel = 'Low' | 'Medium' | 'High';

export type OwaspRiskLevel = 'Note' | 'Low' | 'Medium' | 'High' | 'Critical';

export type OwaspRiskCalculation = {
  likelihoodScore: number;
  impactScore: number;
  likelihoodLevel: OwaspRiskFactorLevel;
  impactLevel: OwaspRiskFactorLevel;
  score: number;
  level: OwaspRiskLevel;
};

export type OwaspRiskData = {
  score: string;
  vector: string;
  level: string;
};

export const OWASP_RISK_FACTOR_KEYS: readonly OwaspRiskFactorKey[] = [
  'SL',
  'M',
  'O',
  'S',
  'ED',
  'EE',
  'A',
  'ID',
  'LC',
  'LI',
  'LA',
  'LAc',
  'FD',
  'RD',
  'NC',
  'PV',
] as const;

export const OWASP_RISK_VECTOR_PREFIX = 'OWASP';
